import { DATA_SOURCE_TYPES, MIXED_DATASOURCES, STRUCTURED_DATASOURCES } from '../constants'

export const getFeatureConfig = (dataSourceType: DATA_SOURCE_TYPES) => {
  const isStructuredDs = STRUCTURED_DATASOURCES.includes(dataSourceType)
  const isMixedDs = MIXED_DATASOURCES.includes(dataSourceType)

  return {
    sideMenu: {
      summary: {
        isHidden: dataSourceType === DATA_SOURCE_TYPES.remote
      },
      databases: {
        isHidden: isMixedDs || dataSourceType === DATA_SOURCE_TYPES.remote
      },
      tables: {
        isHidden: isMixedDs || dataSourceType === DATA_SOURCE_TYPES.remote
      },
      clusters: {
        isHidden:
          isMixedDs ||
          dataSourceType === DATA_SOURCE_TYPES.remote ||
          dataSourceType === DATA_SOURCE_TYPES.glue
      },
      entities: {
        isHidden: dataSourceType === DATA_SOURCE_TYPES.remote
      },
      files: {
        isHidden:
          isStructuredDs ||
          dataSourceType === DATA_SOURCE_TYPES.remote ||
          dataSourceType === DATA_SOURCE_TYPES.confluence ||
          dataSourceType === DATA_SOURCE_TYPES.salesForceMarketingCloud
      },
      blob: {
        isHidden:
          dataSourceType === DATA_SOURCE_TYPES.remote ||
          (isStructuredDs &&
            dataSourceType !== DATA_SOURCE_TYPES.mongoDb &&
            dataSourceType !== DATA_SOURCE_TYPES.cosmosNoSql &&
            dataSourceType !== DATA_SOURCE_TYPES.cosmosMongoDb &&
            dataSourceType !== DATA_SOURCE_TYPES.dynamoDb &&
            dataSourceType !== DATA_SOURCE_TYPES.snowflake &&
            dataSourceType !== DATA_SOURCE_TYPES.glue &&
            dataSourceType !== DATA_SOURCE_TYPES.databricks)
      },
      attributes: {
        isHidden: dataSourceType === DATA_SOURCE_TYPES.remote
      },
      noScanList: {
        isHidden: ![
          DATA_SOURCE_TYPES.aws,
          DATA_SOURCE_TYPES.googleCloudStorage,
          DATA_SOURCE_TYPES.jira,
          DATA_SOURCE_TYPES.azureBlob,
          DATA_SOURCE_TYPES.oracleObjectStorage
        ].find((type) => type == dataSourceType)
      }
    },
    dashboard: {
      widgetStructuredData: {
        isHidden:
          dataSourceType === DATA_SOURCE_TYPES.serviceNow ||
          dataSourceType === DATA_SOURCE_TYPES.hubspot ||
          dataSourceType === DATA_SOURCE_TYPES.salesForce ||
          dataSourceType === DATA_SOURCE_TYPES.salesForceMarketingCloud ||
          dataSourceType === DATA_SOURCE_TYPES.dynamicsSales ||
          dataSourceType === DATA_SOURCE_TYPES.confluence ||
          dataSourceType === DATA_SOURCE_TYPES.marketo ||
          dataSourceType === DATA_SOURCE_TYPES.adp ||
          dataSourceType === DATA_SOURCE_TYPES.workday ||
          dataSourceType === DATA_SOURCE_TYPES.sugarCRM
      },
      widgetObjectTypeAndPolicies: {
        filterCategory: dataSourceType === DATA_SOURCE_TYPES.serviceNow ? 'table' : '',
        urlFilterDander: dataSourceType === DATA_SOURCE_TYPES.serviceNow ? 'Sensitive' : ''
      },
      /* Todo: move this to dashboard config */
      widgetDocumentDistribution: {
        duplicateData: {
          isHidden: dataSourceType === DATA_SOURCE_TYPES.salesForce
        }
      }
    },
    blob: {
      view: {
        showCardView: false, // LA-9129: objectGroupByParent query call is too heavy, must be disabled
        showFilters: true, // Need to have filters for Blobs table view(Cardview is not being used now)
        showFilterCategory: dataSourceType !== DATA_SOURCE_TYPES.serviceNow,
        showFilterSensitive: MIXED_DATASOURCES.includes(dataSourceType),
        showDataExtensionsFilter: dataSourceType === DATA_SOURCE_TYPES.salesForceMarketingCloud,
        showBusinessUnitsFilter: dataSourceType === DATA_SOURCE_TYPES.salesForceMarketingCloud,
        showMetadataColumn: dataSourceType === DATA_SOURCE_TYPES.serviceNow,
        showBlobsListTableFilter: false // Scale is not possible for huge tables list
      }
    },
    file: {
      view: {
        showMetadataColumn: dataSourceType === DATA_SOURCE_TYPES.serviceNow,
        readonlyFilterAttributes:
          dataSourceType === DATA_SOURCE_TYPES.aws ||
          dataSourceType === DATA_SOURCE_TYPES.googleCloudStorage ||
          dataSourceType === DATA_SOURCE_TYPES.azureBlob ||
          dataSourceType === DATA_SOURCE_TYPES.oracleObjectStorage ||
          dataSourceType === DATA_SOURCE_TYPES.gdrive
      }
    },
    objectViewer: {
      view: {
        showIgnoreObjectButton:
          dataSourceType === DATA_SOURCE_TYPES.serviceNow ||
          dataSourceType === DATA_SOURCE_TYPES.aws ||
          dataSourceType === DATA_SOURCE_TYPES.googleCloudStorage ||
          dataSourceType === DATA_SOURCE_TYPES.azureBlob ||
          dataSourceType === DATA_SOURCE_TYPES.oracleObjectStorage ||
          dataSourceType === DATA_SOURCE_TYPES.sharePoint ||
          dataSourceType === DATA_SOURCE_TYPES.gdrive ||
          dataSourceType === DATA_SOURCE_TYPES.oneDrive ||
          dataSourceType === DATA_SOURCE_TYPES.box ||
          dataSourceType === DATA_SOURCE_TYPES.dropbox ||
          dataSourceType === DATA_SOURCE_TYPES.outLook ||
          dataSourceType === DATA_SOURCE_TYPES.gmail ||
          dataSourceType === DATA_SOURCE_TYPES.jira ||
          dataSourceType === DATA_SOURCE_TYPES.smb ||
          dataSourceType === DATA_SOURCE_TYPES.netDocuments ||
          dataSourceType === DATA_SOURCE_TYPES.netAppSmb ||
          dataSourceType === DATA_SOURCE_TYPES.iManage
      }
    },
    mixedDataSourcesSettings: {
      showEntityCreation:
        !STRUCTURED_DATASOURCES.includes(dataSourceType) &&
        dataSourceType !== DATA_SOURCE_TYPES.remote,
      showSourceOfTruth:
        dataSourceType !== DATA_SOURCE_TYPES.salesForce &&
        dataSourceType !== DATA_SOURCE_TYPES.dynamicsSales &&
        dataSourceType !== DATA_SOURCE_TYPES.confluence &&
        dataSourceType !== DATA_SOURCE_TYPES.marketo &&
        dataSourceType !== DATA_SOURCE_TYPES.hubspot &&
        dataSourceType !== DATA_SOURCE_TYPES.smb &&
        dataSourceType !== DATA_SOURCE_TYPES.adp &&
        dataSourceType !== DATA_SOURCE_TYPES.iterable,
      hasDatabases:
        STRUCTURED_DATASOURCES.includes(dataSourceType) &&
        dataSourceType !== DATA_SOURCE_TYPES.bigQuery &&
        dataSourceType !== DATA_SOURCE_TYPES.looker &&
        dataSourceType !== DATA_SOURCE_TYPES.databricks,
      showProjectScanSettings:
        dataSourceType === DATA_SOURCE_TYPES.bigQuery ||
        dataSourceType === DATA_SOURCE_TYPES.looker,
      showCatalogScanSettings: dataSourceType === DATA_SOURCE_TYPES.databricks
    },
    entities: {},
    pia: {
      enableScheduleReminders: false
    }
  }
}
